import { render, staticRenderFns } from "./BaseButtonPrimary.vue?vue&type=template&id=4bb560c2&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bb560c2')) {
      api.createRecord('4bb560c2', component.options)
    } else {
      api.reload('4bb560c2', component.options)
    }
    module.hot.accept("./BaseButtonPrimary.vue?vue&type=template&id=4bb560c2&", function () {
      api.rerender('4bb560c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseButtonPrimary.vue"
export default component.exports